class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
    this.thumbs = [...this.querySelectorAll('[data-carousel-thumb]')];
    this.querySelectorAll('[data-dir]').forEach((button) => {
      button.addEventListener('click', () => this.move(button.dataset.dir === 'next' ? 1 : -1));
    });
    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.goTo(index));
    });
    if (this.track) {
      this.track.addEventListener('scroll', () => window.requestAnimationFrame(() => this.syncThumb()));
    }
    this.syncThumb();
  }

  currentIndex() {
    if (!this.track || !this.slides.length) return 0;
    return Math.round(this.track.scrollLeft / this.track.clientWidth);
  }

  move(step) {
    const next = Math.min(Math.max(this.currentIndex() + step, 0), this.slides.length - 1);
    this.goTo(next);
  }

  goTo(index) {
    const slide = this.slides[index];
    if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  goToMedia(mediaId) {
    if (!mediaId) return;
    const index = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
    if (index >= 0) this.goTo(index);
  }

  syncThumb() {
    const index = this.currentIndex();
    this.thumbs.forEach((thumb, thumbIndex) => {
      thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
    });
  }
}

customElements.define('product-carousel', ProductCarousel);

function formatShopifyMoney(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents);
  }
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

function updateProductForm(form) {
  const selects = [...form.querySelectorAll('[data-variant-select]')];
  const optionValues = selects.map((input) => input.value);
  const variantData = form.querySelector('[data-product-variants]');
  if (!variantData) return;

  const variants = JSON.parse(variantData.textContent);
  const variant = variants.find((candidate) => candidate.options.every((option, index) => option === optionValues[index]));
  if (!variant) return;

  form.querySelector('[name="id"]').value = variant.id;

  const section = form.closest('.section');
  const price = section.querySelector('[data-variant-price]');
  const compare = section.querySelector('[data-variant-compare]');
  if (price) price.textContent = formatShopifyMoney(variant.price);
  if (compare) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compare.hidden = false;
      compare.textContent = formatShopifyMoney(variant.compare_at_price);
    } else {
      compare.hidden = true;
      compare.textContent = '';
    }
  }

  const submit = form.querySelector('[name="add"]');
  if (submit) {
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
  }

  selects.forEach((select, index) => {
    const field = select.closest('[data-option-index]');
    if (!field) return;
    const selectedLabel = field.querySelector('[data-selected-option]');
    if (selectedLabel) selectedLabel.textContent = select.value;
    field.querySelectorAll('[data-swatch-value]').forEach((button) => {
      const selected = button.dataset.swatchValue === select.value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  });

  const url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url.toString());

  const carousel = section.querySelector('product-carousel');
  if (carousel && variant.featured_media && variant.featured_media.id) {
    carousel.goToMedia(variant.featured_media.id);
  }
}

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  updateProductForm(select.closest('form'));
});

document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-swatch-value]');
  if (!swatch) return;
  const form = swatch.closest('form');
  const select = form.querySelector(`[data-option-index="${swatch.dataset.optionIndex}"] [data-variant-select]`);
  if (!select) return;
  select.value = swatch.dataset.swatchValue;
  select.dispatchEvent(new Event('change', { bubbles: true }));
});
